import { Routes, Route, Navigate } from "react-router-dom";
import OnDemand from "../cloneApps/onDemand/OnDemand";
import Home from "../Home/Home";

import ScrollToTop from "./ScrollToTop";
import Layout from "../Layouts/Layout";
import Login from "../login/Login";

// User Layout Components

// const About = lazy(() => import("../About/About"));
import AboutNew from "../aboutNew/AboutNew";
import Contact from "../Contact/Contact";
import ComingSoon from "../comingSoon/ComingSoon";
import ThankYou from "../thankyou/ThankYou";
import PrivacyPolicy from "../privacy/PrivacyPolicy";
import PageNotFound from "../404page/PageNotFound";
import Pricing from "../pricing/Pricing";
// import PriceNew from "../pricingNew/PriceNew";
import MediaPage from "../Media_Page/MediaPage";


// Clone Apps
import CloneAppsDynamic from "../cloneApps/UberClone/CloneAppsDynamic";
import LyftClone from "../cloneApps/LyftClone/LyftClone";
import ZipcarClone from "../cloneApps/ZipcarClone/ZipcarClone";
import CabifyClone from "../cloneApps/cabifyClone/CabifyClone";
import BoltClone from "../cloneApps/boltClone/BoltClone";
import XanhClone from "../cloneApps/xanhClone/XanhClone";
import MaiLinhClone from "../cloneApps/maiLinhClone/MaiLinhClone";
import ZoomZoom from "../cloneApps/zoomZoom/ZoomZoom";
import YellowCab from "../cloneApps/yellowCab/YellowCab";
import URideClone from "../cloneApps/uRideClone/URideClone";
import Taxis99 from "../cloneApps/99taxis/Taxis99";
import UberClone from "../cloneApps/UberClone/UberClone";
import EasyTaxi from "../cloneApps/easyTaxi/EasyTaxi";
import VadeTaxi from "../cloneApps/vadeTaxi/VadeTaxi";
import FreeNow from "../cloneApps/freeNow/FreeNow";
import BlaBlaClone from "../cloneApps/blabla/BlaBlaClone";
import BlaBlaItaly from "../cloneApps/blablaItaly/BlaBlaItaly";
import GrabClone from "../cloneApps/grabClone/GrabClone";
import PoparideClone from "../cloneApps/poparide/PoparideClone";
import GroceryApp from "../cloneApps/groceryApp/GroceryApp";
import BlinkitClone from "../cloneApps/blinkit/BlinkitClone";
import Bigbasket from "../cloneApps/bigbasket/Bigbasket";
import FreshDirect from "../cloneApps/freshDirect/FreshDirect";
import Swiggy from "../cloneApps/swiggy/Swiggy";
import CareemClone from "../cloneApps/careem/CareemClone";
import UberEats from "../cloneApps/uberEats/UberEats";
import DoordashClone from "../cloneApps/doordash/DoordashClone";
import DeliverooClone from "../cloneApps/deliveroo/DeliverooClone";
import OlaClone from "../cloneApps/olaClone/OlaClone";
import BlueSmart from "../cloneApps/blueSmart/BlueSmart";


// Industries
import Restaurant from "../restaurant/Restaurant";
import Telemedicine from "../telemedicine/Telemedicine";
import Education from "../education/Education";
import FoodAndGrocery from "../foodAndGrocery/FoodAndGrocery";
import HealthCare from "../healthcare/HealthCare";
import Industries from "../industries/Industries";
import Pharmacy from "../pharmacy/Pharmacy";
import Ecommerce from "../ecommerce/Ecommerce";


// Solutions
import ShuttleSoftware from "../shuttle_software/ShuttleSoftware";
import CarRental from "../carRental/CarRental";
import CarPooling from "../carPooling/CarPooling";
import WhiteLabelSolutions from "../WhiteLabelSolutions/WhiteLabel";
import BikeRental from "../bikeRental/BikeRental";
import TaxiDispatchSoftware from "../taxiDispatchSoftware/taxiDispatchSoftware";
import CustomAppDevelopment from "../customAppDevelopment/CustomAppDevelopment";
import WebAppDevelopment from "../webAppDevelopment/WebAppDevelopment";
import TaxiSoftware from "../TaxiSoftware/TaxiSoftware";


// blogs front end
import BlogListing from "../Blogs/BlogListing";
import BlogDetails from "../BlogDetails/BlogDetails";
import AIBlogDetail from "../AIblogDetail/AIBlogDetail";

// Case Study front end
import CaseNewList from "../caseNew/list/CaseNewList";
import CaseNewDetails from "../caseNew/details/CaseNewDetails";
// const CaseStudyListing = lazy(() => import("../caseStudy/CaseStudyListing"));
// const CaseStudyDetailNew = lazy(() => import("../caseStudyDetails/CaseStudyDetailNew"));

// features front end
import Features from "../Features/Features";
import FeatureNew from "../featureNew/FeatureNew";

// Admin Panel Components
// Admin Panel Components
import AdminLayout from "../Layouts/AdminLayout";
import Dashboard from "../adminPanel/dashboard/Dashboard";
import BlogListingAdmin from "../adminPanel/blogs/BlogListingAdmin";
import AddBlogAdmin from "../adminPanel/blogs/AddBlogAdmin";
import EditBlogAdmin from "../adminPanel/blogs/EditBlogAdmin";
import AIBlogs from "../adminPanel/aiBlogs/AIBlogs";
import AddAIBlogs from "../adminPanel/aiBlogs/AddAIBlogs";
import EditAIBlogs from "../adminPanel/aiBlogs/EditAIBlogs";
import AuthorListing from "../adminPanel/author/AuthorListing";
import AddAuthor from "../adminPanel/author/AddAuthor";
import EditAuthor from "../adminPanel/author/EditAuthor";
import Tags from "../adminPanel/tags/Tags";
import AddTags from "../adminPanel/tags/AddTags";
import EditTags from "../adminPanel/tags/EditTags";
import Category from "../adminPanel/category/Category";
import AddCategory from "../adminPanel/category/AddCategory";
import EditCategory from "../adminPanel/category/EditCategory";
import SeoListing from "../adminPanel/seo/SeoListing";
import SeoCreate from "../adminPanel/seo/SeoCreate";
import SeoEdit from "../adminPanel/seo/SeoEdit";
import CaseStudyListAdmin from "../adminPanel/caseStudy/CaseStudyListAdmin";
import AddCaseStudy from "../adminPanel/caseStudy/AddCaseStudy";
import EditCaseStudy from "../adminPanel/caseStudy/EditCaseStudy";
import CaseCategoryList from "../adminPanel/caseCategory/CaseCategoryList";
import AddCaseCategory from "../adminPanel/caseCategory/AddCaseCategory";
import EditCaseCategory from "../adminPanel/caseCategory/EditCaseCategory";
import NewsLetter from "../adminPanel/newsLetter/NewsLetter";
import ContactListingAdmin from "../adminPanel/contact/contactListingAdmin";
import FeaturePageListing from "../adminPanel/webPages/FeaturePageListing";
import FeaturePageCreate from "../adminPanel/webPages/FeaturePageCreate";
import FeaturePageEdit from "../adminPanel/webPages/FeaturePageEdit";
import FeatureEdit from "../adminPanel/feature/FeatureEdit";
import FeatureCreate from "../adminPanel/feature/FeatureCreate";
import FeatureListing from "../adminPanel/feature/FeatureListing";
import AdminMedia from "../adminPanel/media/AdminMedia";
import AddMedia from "../adminPanel/media/AddMedia";
import EditMedia from "../adminPanel/media/EditMedia";
import CloneApps from "../adminPanel/cloneApps/CloneApps";
import AddCloneApps from "../adminPanel/cloneApps/AddCloneApps";
import EditCloneApps from "../adminPanel/cloneApps/EditCloneApps";
import AddTestimonial from "../adminPanel/testimonial/AddTestimonial";
import TestimonialList from "../adminPanel/testimonial/TestimonialList";
import EditTestimonial from "../adminPanel/testimonial/EditTestimonial";
import EmailDynamic from "../adminPanel/emailDynamic/EmailDynamic";
import AddEmails from "../adminPanel/emailDynamic/AddEmails";
import EditEmails from "../adminPanel/emailDynamic/EditEmails";
import ClientLogos from "../adminPanel/clientLogos/ClientLogos";
import AddClientLogo from "../adminPanel/clientLogos/AddClientLogo";
import EditClientLogo from "../adminPanel/clientLogos/EditClientLogo";
import AdminPrice from "../adminPanel/pricing/AdminPrice";
import AddPrice from "../adminPanel/pricing/AddPrice";
import EditPrice from "../adminPanel/pricing/EditPrice";
import BusManagement from "../busManagement/BusManagement";
import Limo from "../limo/Limo";


export const NavRouter = () => {
  return (
    <>


      <ScrollToTop />
      <Routes>

        {/*=============== Admin Layout Start ===============*/}
        <Route path="Login" element={<Login />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />

          <Route path="blog" element={<BlogListingAdmin />} />
          <Route path="add-blog" element={<AddBlogAdmin />} />
          <Route path="edit-blog/:blog_id" element={<EditBlogAdmin />} />

          <Route path="ai-blog" element={<AIBlogs />} />
          <Route path="add-ai-blog" element={<AddAIBlogs />} />
          <Route path="edit-ai-blog/:aiblog_id" element={<EditAIBlogs />} />

          <Route path="author" element={<AuthorListing />} />
          <Route path="add-author" element={<AddAuthor />} />
          <Route path="edit-author/:author_id" element={<EditAuthor />} />

          <Route path="client-logos" element={<ClientLogos />} />
          <Route path="add-client-logo" element={<AddClientLogo />} />
          <Route path="edit-client-logo/:clientlogo_id" element={<EditClientLogo />} />

          <Route path="tags" element={<Tags />} />
          <Route path="add-tags" element={<AddTags />} />
          <Route path="edit-tags/:tags_id" element={<EditTags />} />

          <Route path="category" element={<Category />} />
          <Route path="add-category" element={<AddCategory />} />
          <Route path="edit-category/:category_id" element={<EditCategory />} />

          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />

          <Route path="feature-pages" element={<FeaturePageListing />} />
          <Route path="add-feature-page" element={<FeaturePageCreate />} />
          <Route path="edit-feature-page/:featurepage_id" element={<FeaturePageEdit />} />

          <Route path="features" element={<FeatureListing />} />
          <Route path="add-feature" element={<FeatureCreate />} />
          <Route path="edit-feature/:featurepage_id" element={<FeatureEdit />} />

          <Route path="price" element={<AdminPrice />} />
          <Route path="add-price" element={<AddPrice />} />
          <Route path="edit-price/:price_id" element={<EditPrice />} />

          <Route path="case-study" element={<CaseStudyListAdmin />} />
          <Route path="add-case-study" element={<AddCaseStudy />} />
          <Route path="edit-case-study/:casestudy_id" element={<EditCaseStudy />} />

          <Route path="media" element={<AdminMedia />} />
          <Route path="add-media" element={<AddMedia />} />
          <Route path="edit-media/:media_id" element={<EditMedia />} />

          <Route path="case-category" element={<CaseCategoryList />} />
          <Route path="add-case-category" element={<AddCaseCategory />} />
          <Route path="edit-case-category/:casecategory_id" element={<EditCaseCategory />} />

          <Route path="clone-app" element={<CloneApps />} />
          <Route path="add-clone-app" element={<AddCloneApps />} />
          <Route path="edit-clone-app/:cloneapp_url" element={<EditCloneApps />} />

          <Route path="testimonial" element={<TestimonialList />} />
          <Route path="add-testimonial" element={<AddTestimonial />} />
          <Route path="edit-testimonial/:testimonial_id" element={<EditTestimonial />} />

          <Route path="emails" element={<EmailDynamic />} />
          <Route path="add-emails" element={<AddEmails />} />
          <Route path="edit-emails/:email_id" element={<EditEmails />} />

          <Route path="contact" element={<ContactListingAdmin />} />
          <Route path="newsletter" element={<NewsLetter />} />
        </Route>
        {/*=============== Admin Layout Finish ===============*/}


        {/*================ User Layout Routes ================*/}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          <Route path="about" element={<AboutNew />} />
          {/* <Route path="about" element={<About />} /> */}
          <Route path="contact" element={<Contact />} />
          <Route path="thankyou" element={<ThankYou />} />
          <Route path="404" element={<PageNotFound />} />
          <Route path="*" element={<Navigate to={"/404"} />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="pricing" element={<Pricing />} />
          {/* <Route path="pricingnew" element={<PriceNew />} /> */}
          <Route path="media" element={<MediaPage />} />
          <Route path="coming-soon" element={<ComingSoon />} />


          {/* Blog Front End Routes */}
          <Route path="blog" element={<BlogListing />} />
          <Route path="blog/:blog_slug" element={<BlogDetails />} />
          <Route path="ai-blog/:aiblog_slug" element={<AIBlogDetail />} />


          {/* Case Study front end Routes */}
          <Route path="case-study" element={<CaseNewList />} />
          <Route path="case-study/:casestudy_slug" element={<CaseNewDetails />} />
          {/* <Route path="case-study" element={<CaseStudyListing />} /> */}
          {/* <Route path="case-study/:casestudy_slug" element={<CaseStudyDetailNew />} /> */}
          {/* <Route path="case-study" element={<CaseStudy />} /> */}
          {/* <Route path="case-study-detail" element={<CaseStudyDetail />} /> */}


          {/* Feature front end Routes */}
          <Route path="features/:featurepageId" element={<Features />} />
          <Route path="features/taxi-software" element={<FeatureNew />} />
          {/* <Route path="features" element={<Features />} /> */}


          {/* All Solution Routes */}
          <Route path="white-lable-carpool-app-dispatch-software" element={<CarPooling />} />
          <Route path="best-taxi-dispatch-software" element={<TaxiSoftware />} />
          <Route path="shuttle-software" element={<ShuttleSoftware />} />
          <Route path="car-rental-software" element={<CarRental />} />
          <Route path="white-label-solutions" element={<WhiteLabelSolutions />} />
          <Route path="bike-rental" element={<BikeRental />} />
          <Route path="airport-transfer-software" element={<TaxiDispatchSoftware />} />
          <Route path="custom-app-development" element={<CustomAppDevelopment />} />
          <Route path="web-app-development" element={<WebAppDevelopment />} />
          <Route path="on-demand-delivery-app" element={<OnDemand />} />
          <Route path="bus-management-software" element={<BusManagement />} />
          <Route path="best-limo-booking-software" element={<Limo />} />


          {/*All Industries Routes */}
          <Route path="best-logistic-app-development-company" element={<Industries />} />
          <Route path="custom-healthcare-app-development-services" element={<HealthCare />} />
          <Route path="food-grocery-delivery-app-development-company" element={<FoodAndGrocery />} />
          <Route path="best-pharmacy-app-development-company" element={<Pharmacy />} />
          <Route path="ecommerce-mobile-app-development-company" element={<Ecommerce />} />
          <Route path="education-app-development-services" element={<Education />} />
          <Route path="telemedicine-app-development-company" element={<Telemedicine />} />
          <Route path="restaurant-app-development-company" element={<Restaurant />} />


          {/* All Clone App Routes*/}
          <Route path="clone-app/:cloneapp_url" element={<CloneAppsDynamic />} />
          <Route path="clone-app/lyft-clone-app" element={<LyftClone />} />
          <Route path="clone-app/zipcar-clone-app" element={<ZipcarClone />} />
          <Route path="clone-app/cabify-clone-app" element={<CabifyClone />} />
          <Route path="clone-app/bolt-clone-app" element={<BoltClone />} />
          <Route path="clone-app/mai-linh-clone-app" element={<MaiLinhClone />} />
          <Route path="clone-app/xanh-sm-clone-app" element={<XanhClone />} />
          <Route path="clone-app/zoom-zoom-clone-app" element={<ZoomZoom />} />
          <Route path="clone-app/yellow-cab-clone-app" element={<YellowCab />} />
          <Route path="clone-app/uride-clone-app" element={<URideClone />} />
          <Route path="clone-app/easy-taxi-clone-app" element={<EasyTaxi />} />
          <Route path="clone-app/va-de-taxi-clone-app" element={<VadeTaxi />} />
          <Route path="clone-app/free-now-clone-app" element={<FreeNow />} />
          <Route path="clone-app/99taxis-clone-app" element={<Taxis99 />} />
          <Route path="clone-app/uber-clone-app" element={<UberClone />} />
          <Route path="clone-app/blabla-car-clone-app" element={<BlaBlaClone />} />
          <Route path="clone-app/blabla-car-clone-app-italy" element={<BlaBlaItaly />} />
          <Route path="clone-app/grab-clone-app" element={<GrabClone />} />
          <Route path="clone-app/poparide-clone-app" element={<PoparideClone />} />
          <Route path="clone-app/grocery-clone-app" element={<GroceryApp />} />
          <Route path="clone-app/blinkit-clone-app" element={<BlinkitClone />} />
          <Route path="clone-app/bigbasket-clone-app" element={<Bigbasket />} />
          <Route path="clone-app/freshdirect-clone-app" element={<FreshDirect />} />
          <Route path="clone-app/swiggy-clone-app" element={<Swiggy />} />
          <Route path="clone-app/careem-clone-app" element={<CareemClone />} />
          <Route path="clone-app/uber-eats-clone-app" element={<UberEats />} />
          <Route path="clone-app/doordash-clone-app" element={<DoordashClone />} />
          <Route path="clone-app/deliveroo-clone-app" element={<DeliverooClone />} />
          <Route path="clone-app/ola-clone-app" element={<OlaClone />} />
          <Route path="clone-app/blue-smart-clone-app" element={<BlueSmart />} />
          

          {/* Redirections */}
          <Route path="/car-pooling" element={<Navigate to="/white-lable-carpool-app-dispatch-software" replace />} />
          <Route path="/taxi-software" element={<Navigate to="/best-taxi-dispatch-software" replace />} />
          <Route path="/car-rental" element={<Navigate to="/car-rental-software" replace />} />
          <Route path="/industries" element={<Navigate to={"/best-logistic-app-development-company"} replace />} />
          <Route path="healthcare" element={<Navigate to={"/custom-healthcare-app-development-services"} replace />} />
          <Route path="food-and-grocery-app" element={<Navigate to={"/food-grocery-delivery-app-development-company"} replace />} />
          <Route path="pharmacy-app" element={<Navigate to={"/best-pharmacy-app-development-company"} replace />} />
          <Route path="ecommerce-app" element={<Navigate to={"/ecommerce-mobile-app-development-company"} replace />} />
          <Route path="lyft-clone-app" element={<Navigate to={"/clone-app/lyft-clone-app"} replace />} />
          <Route path="uber-clone-app" element={<Navigate to={"/clone-app/uber-clone-app"} replace />} />
          <Route path="/best-taxi-dispatc" element={<Navigate to="/best-taxi-dispatch-software" replace />} />
          <Route path="/healthcare" element={<Navigate to="/custom-healthcare-app-development-services" replace />} />
          <Route path="/ecommerce-app" element={<Navigate to="/ecommerce-mobile-app-development-company" replace />} />
          <Route path="/blog-detail/undefined" element={<Navigate to="/blog" replace />} />
          <Route path="/casestudy/ontap-case-study" element={<Navigate to="/case-study/ontap-case-study" replace />} />
          <Route path="/casestudy/togopool-case-study" element={<Navigate to="/case-study/togopool-case-study" replace />} />
          <Route path="/best-taxi-dispatch-software/best-taxi-dispatch-software" element={<Navigate to="/best-taxi-dispatch-software" replace />} />
          <Route path="/blog/how-to-choose-the-right-taxi-dispatch-software-for-your-growing-busin" element={<Navigate to="/blog/how-to-choose-the-right-taxi-dispatch-software-for-your-growing-business" replace />} />
          <Route path="/blog/key-considerations-for-choosing-taxi-management-software-for-g" element={<Navigate to="/blog/key-considerations-for-choosing-taxi-management-software-for-growing-fleets" replace />} />
          <Route path="/blog/what-is-taxi-dispatch-software-and-how-it-can-transform-yo" element={<Navigate to="/blog/what-is-taxi-dispatch-software-and-how-it-can-transform-your-taxi-business" replace />} />
          <Route path="blog/a-comprehensive-guide-to-taxi-dispatch-system-price" element={<Navigate to="/blog/a-comprehensive-guide-to-taxi-dispatch-system-prices-and-roi" replace />} />
          <Route path="/blog/a-comprehensive-guide-to-custom-app-vs-white-label-for-ta" element={<Navigate to="/blog/a-comprehensive-guide-to-custom-app-vs-white-label-for-taxi-companies" replace />} />
          <Route path="/features/66f7a4b7770fe7ade1f72f93" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/features/66f7a494770fe7ade1f72f84" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/features/66f7a486770fe7ade1f72f80" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/features/66f7a4ab770fe7ade1f72f8e" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/features/66f7a49f770fe7ade1f72f89" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/features/66f295c630826ed7475eee6a" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/features/66f3ba421e2135e008de309d" element={<Navigate to="/features/taxi-dispatch-software" replace />} />
          <Route path="/blog/create-lyft-and-uber-alternative-app-to-start-your-own-taxibusiness" element={<Navigate to="/blog/create-lyft-and-uber-alternative-app-to-start-your-own-taxi-business" replace />} />
          <Route path="/carpool-software" element={<Navigate to="/white-lable-carpool-app-dispatch-software" replace />} />
          <Route path="/blog/the-rise-of-white-label-taxi-apps:-what-you-need-to-know" element={<Navigate to="/blog/the-rise-of-white-label-taxi-apps-what-you-need-to-know" replace />} />
          <Route path="/bike-renta" element={<Navigate to="/bike-rental" replace />} />
          <Route path="/blog/top-10-taxi-dispatch-software-providers" element={<Navigate to="/blog/top-taxi-dispatch-software-provider-features-pricing-and-reviews" replace />} />
          <Route path="/taxi-software/features" element={<Navigate to="/features/taxi-software" replace />} />
          <Route path="/careers" element={<Navigate to="/" replace />} />
          <Route path="/custom-app-development(Custom" element={<Navigate to="/custom-app-development" replace />} />
          <Route path="/food-grocery-delivery-app-d" element={<Navigate to="/food-grocery-delivery-app-development-company" replace />} />
          <Route path="/blog/guide-on-taxi-app-deve" element={<Navigate to="/blog/guide-on-taxi-app-development-all-that-you-ought-to-be-aware-in-2025" replace />} />
          <Route path="blog/why-do-modern-passenger-transport-companies-c" element={<Navigate to="/blog/why-do-modern-passenger-transport-companies-choose-white-label-taxi-app-solutions" replace />} />
          <Route path="/news" element={<Navigate to="/media" replace />} />
          <Route path="/blog/the-role-of-taxi-scheduling-software-in-modern-transportati" element={<Navigate to="/blog/the-role-of-taxi-scheduling-software-in-modern-transportation" replace />} />
          <Route path="/telemedicine-app-developmen" element={<Navigate to="/blog/telemedicine-app-development-key-factors-to-consider-for-your-healthcare-venture" replace />} />
          <Route path='/blog/telemedicine-app-development-key-factors-to-consider-for-your-healthcare-venture”' element={<Navigate to="/blog/telemedicine-app-development-key-factors-to-consider-for-your-healthcare-venture" replace />} />
          <Route path="/blog/2025-and-beyond-how-taxi-dispatch-software-is-driving-innovation-in-the-uk-and-germanys-transport-industry" element={<Navigate to="/blog/how-taxi-software-enhances-local-transportation-services-in-the-uk-and-germany" replace />} />
          <Route path="/blog/why-carpooling-open-source-software-is-growing-in-the-uk" element={<Navigate to="/blog/why-taxi-software-dispatch-adoption-is-growing-fast-in-uk-germany" replace />} />
          <Route path="/blog/why-taxi-businesses-in-taiwan-are-switching-to-white-label-software)" element={<Navigate to="/blog/why-taxi-businesses-in-taiwan-are-switching-to-white-label-software" replace />} />
          <Route path="/blog/how-to-choose-the-right-taxi-dispatch-software-for" element={<Navigate to="/blog/how-to-choose-the-right-taxi-dispatch-software-for-your-growing-business" replace />} />
          <Route path="/blog/maximizing-t" element={<Navigate to="/blog/maximizing-the-potential-of-your-taxi-business-with-a-lyft-clone-app" replace />} />
          <Route path="/blog/the-benefits-taxi-businesses-gain-from-a-taxi-serv" element={<Navigate to="/blog/benefits-of-taxi-cab-dispatch-software-system-for-taxi-companies" replace />} />
          <Route path="/case-study-listing" element={<Navigate to="/case-study" replace />} />
          <Route path="/casestudy" element={<Navigate to="/case-study" replace />} />
          <Route path="/custom-app-development(Customized" element={<Navigate to="/custom-app-development" replace />} />

        </Route>
      </Routes>
    </>
  );
};
